<template>
  <div>
    <b-row class="">
      <b-col cols="12">
        <b-card>
          <div slot="header">ایجاد سابقه شغلی</div>
          <LoadingSpinner
            :loading="isLoading"
            :text="this.$lang.sending_data"
          />
          <WorkExperienceForm
            v-show="!isLoading"
            ref="workExperienceForm"
            :parentPermissions="parentPermissions"
            @cancel="cancel"
            @submit="save"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import WorkExperienceForm from "./../forms/workExperienceForm";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";

export default {
  inject: ["personJobExperienceRepository"],
  components: {
    WorkExperienceForm,
    LoadingSpinner,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => []
    },
    code: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    async save(payload) {
      try {
        this.isLoading = true;
        const response = await this.personJobExperienceRepository.create(
          payload,
          this.code
        );
        this.$notify.success(response.data.message);
        this.cancel();
        const id = pathOr(null, ["data", "data"], response);
        this.$emit("getData");
        this.$emit("personRelation", { id });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
